<template>
  <div id="app">
    <alert-alert />
    <div class="content-container-for-sticky-footer">
      <Header />
      <!-- Binding a key to the full path will remount a view if the detail endpoint changes -->
      <router-view :key="$route.fullPath" />
    </div>
    <Footer />
    <AgreeToTermsPopup />
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'

import Header from '@/components/Header'
import Footer from '@/components/Footer'
import AgreeToTermsPopup from '@/components/popups/AgreeToTermsPopup'

export default {
  name: 'App',
  components: {
    AgreeToTermsPopup,
    Footer,
    Header,
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters(['userIsLoggedIn']),
  },
  watch: {
    '$route.path': function() {
      // TODO: NRS 7-12-2019. I am not sure what this refers to but I'll leave this in here
      // Force unblock scrolling blocked by v-modal component
      document.body.classList.remove('v--modal-block-scroll')
    },
  },
  created() {
    if (this.userIsLoggedIn) {
      this.refreshCurrentUser()
      window.Intercom('update', {
        app_id: process.env.VUE_APP_INTERCOM_ID,
        name: this.user.fullName,
        email: this.user.email,
      })
    }
  },
  methods: {
    ...mapActions(['refreshCurrentUser']),
  },
}
</script>

<style lang="scss">
@import './styles/reset';
@import './styles/base';

#app {
  // specifically for Subheader img overflow
  min-height: 100%;
  height: 100%;
  background-color: white;
  // overflow-x: hidden;

  display: flex;
  flex-direction: column;
}

.content-container-for-sticky-footer {
  display: flex;
  flex-direction: column;
  flex: 1 0 auto; // sticky footer hack
}
</style>
